import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faYoutube,
  faInstagram
} from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import FooterLogo from '../../Components/logos/FooterLogo';
import SubscriptionInput from '../../Components/subscriptionInput/SubscriptionInput';
import './footer.css';

function Footer() {
  return (
    <section className="footer">
      <Container>
        <Row>
          <Col md={3}>
            <FooterLogo />
            <p className="copyright">© 2021 Meri Sehat. All rights reserved.</p>
            <div className="social_icons">
              <Link to="/">
                <FontAwesomeIcon icon={faFacebookF} />
              </Link>
              <Link to="/">
                <FontAwesomeIcon icon={faInstagram} />
              </Link>
              <Link to="/">
                <FontAwesomeIcon icon={faYoutube} />
              </Link>
            </div>
          </Col>
          <Col md={4}>
            <div className="d-flex justify-content-between">
              <ul className="footer_links">
                <Link to="/">Sehat A to Z </Link>
                <Link to="/">HealthCheck </Link>
                <Link to="/">Find a Doctor </Link>
                <Link to="/">Health Tips </Link>
                <Link to="/">Buy Subscription</Link>
              </ul>
              <ul className="footer_links">
                <Link to="/">About Meri Sehat </Link>
                <Link to="/">Terms & Conditions </Link>
                <Link to="/">Privacy Policy </Link>
                <Link to="/">FAQs </Link>
                <Link to="/">Contact us</Link>
              </ul>
            </div>
          </Col>
          <Col className="subscription_cont" md={5}>
            <p className="subscription_heading">
              Feel empowered in your wellness journey.{' '}
              <span className="d-lg-block d-inline-block">
                Sign up for our newsletter
              </span>
            </p>
            <SubscriptionInput />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Footer;
